"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchMonthFormatOptionsRequestStatus = exports.getFetchDateTimeFormatOptionsRequestStatus = exports.getCreateCustomDateTimeFormatRequestStatus = exports.getDateTimeFormatOptions = exports.getMonthFormatOptions = exports.getLanguages = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-ui-sdk/RequestStatuses/selectors");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var getLanguages = function getLanguages(state) {
  return state.modules.website.blogs.entities.languages;
};

exports.getLanguages = getLanguages;
var getMonthFormatOptions = (0, _reselect.createSelector)([getLanguages], function (languages) {
  return languages.get('monthFormatOptions');
});
exports.getMonthFormatOptions = getMonthFormatOptions;
var getDateTimeFormatOptions = (0, _reselect.createSelector)([getLanguages], function (languages) {
  return languages.get('dateTimeFormatOptions');
});
exports.getDateTimeFormatOptions = getDateTimeFormatOptions;
var getCreateCustomDateTimeFormatRequestStatus = (0, _getRequestStatus.default)(_actions.LanguageActionTypes.CREATE_CUSTOM_DATE_TIME_FORMAT_OPTION);
exports.getCreateCustomDateTimeFormatRequestStatus = getCreateCustomDateTimeFormatRequestStatus;

var getFetchDateTimeFormatOptionsRequestStatus = function getFetchDateTimeFormatOptionsRequestStatus(language, selectedFormat) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.LanguageActionTypes.FETCH_DATETIME_FORMAT_OPTIONS + "&language=" + language + "&selected=" + selectedFormat) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getFetchDateTimeFormatOptionsRequestStatus = getFetchDateTimeFormatOptionsRequestStatus;

var getFetchMonthFormatOptionsRequestStatus = function getFetchMonthFormatOptionsRequestStatus(language, selectedFormat) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.LanguageActionTypes.FETCH_MONTH_FORMAT_OPTIONS + "&language=" + language + "&selected=" + selectedFormat) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getFetchMonthFormatOptionsRequestStatus = getFetchMonthFormatOptionsRequestStatus;